module.exports = __webpack_public_path__ + "static/saint-private-club-86c95816605398056fd98428e6e9d8de.jpg";